<template>
    <b-card
            border-variant="gray-400"
            class="property-details-description"
    >
        <b-row>
            <b-col class="d-flex">
                <h2 class="mb-0">
                    Description
                </h2>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                v-if="propertyAppResource.isSold"
                class="font-weight-bold mt-3"
            >
                This property is not currently for sale on Milestones.
            </b-col>
            <template v-if="propertyAppResource.details.description">
                <b-col>
                    <div
                        class="text-gray-900 mt-2"
                        v-html="formatedDescription"
                    />
                </b-col>
            </template>
        </b-row>
        <hr
                v-if="propertyAppResource.details.description || propertyAppResource.isSold"
                class="bg-gray-400"
        >
        <b-row>
            <b-col>
                <h2>Details</h2>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col
                xl
                class="table-responsive"
            >
                <b-table
                        class="table-container mb-0"
                        stacked
                        :fields="tableData.firstSection.fields"
                        :items="tableData.firstSection.items"
                >
                    <template v-slot:cell(hoa)="row">
                        <div class="hoa-items">
                            <span
                                    class="d-block"
                                    v-for="(item,key) in row.item.hoa"
                                    :key="key"
                            >
                                {{ item }}
                            </span>
                        </div>
                    </template>
                </b-table>
            </b-col>
            <b-col
                xl
                class="table-responsive"
            >
                <b-table
                        class="table-container mb-0"
                        stacked
                        :fields="tableData.secondSection.fields"
                        :items="tableData.secondSection.items"
                >
                    <template v-slot:cell(openHouses)="row">
                        <div class="hoa-items">
                            <span
                                class="d-block"
                                v-for="(item,key) in row.item.openHouses"
                                :key="key"
                            >
                                {{ item }}
                            </span>
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    import './PropertyDetailsDescription.scss';
    import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
    import {niceNumberFormatFilter} from '../../../filters/niceNumberFormat.filter';
    import {SIZE_UNIT_MAPING} from '../../../../helpers/variables';
    import {lotSizeRender} from '../../../../helpers/functions';
    import get from 'lodash/get';
    import isEmpty from "lodash/isEmpty";
    import upperFirst from "lodash/upperFirst";

    export default {
        name: 'PropertyDetailsDescription',
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
        },
        data() {
            return {
                dateOptions: {
                    month: "long",
                    day: "numeric",
                },
            };
        },
        computed: {
            formatedDescription() {
                let description = this.propertyAppResource.details.description || '';
                if (description == '') return '';

                var re = new RegExp('[\\*;]+'),
                    reStart = new RegExp('^[\\*; ]+'),
                    chunks = description.replace(reStart, '').split(re);

                return chunks.shift() + (
                    chunks.length > 0
                        ? '<br><ul><li>' + chunks.join('</li><li>') + '</li></ul>'
                        : ''
                );
            },
            isOffMarket() {
                /* after the update on milestones engine this field comes in requests snake case*/
                return !!this.propertyAppResource.offMarketAt || !!this.propertyAppResource.off_market_at;
            },
            daysOnMarket() {
                let daysFromChangedAt = this.propertyAppResource.originalChangedAt
                        ? Math.floor(
                            (new Date() - new Date(this.propertyAppResource.originalChangedAt)) /
                                (1000 * 60 * 60 * 24)
                        ) : 0,
                    updatedAt = this.propertyAppResource.updatedAt
                        ? Math.floor(
                            (new Date() - new Date(this.propertyAppResource.updatedAt)) /
                                (1000 * 60 * 60 * 24)
                        ) : 0,
                    days = Math.max(
                        parseInt(this.propertyAppResource.details.daysOnHJI || 0),
                        parseInt(this.propertyAppResource.details.daysOnMarket || 0),
                        parseInt(daysFromChangedAt || updatedAt || 1)
                    ),
                    plural = days === 1 ? '' : 's';
                return !this.isOffMarket
                    ? `${days} day${plural} on Milestones`
                    : 'Off Market';
            },
            tableData() {
                let tableData = {
                    firstSection: [],
                    secondSection: [],
                };

                tableData.firstSection = this.buildSectionData(this.firstSection);
                tableData.secondSection = this.buildSectionData(this.secondSection);

                return tableData;
            },
            firstSection() {
                let lotSizeValue = this.propertyAppResource.lotSize;
                let lotSizeUnits = SIZE_UNIT_MAPING[this.propertyAppResource.lotSizeUnits];

                let lotSize = lotSizeRender(lotSizeValue);
                lotSizeValue = lotSize.value;
                lotSizeUnits = lotSize.unit;

                let features = (!this.isOffMarket && !this.isSold)
                    ? [
                        {
                            key: 'status',
                            label: 'Status',
                            value: upperFirst(this.propertyAppResource.status),

                        },
                        {
                            key: 'updated',
                            label: 'Listed',
                            value: this.daysOnMarket,
                        },
                    ] : [];

                features = [
                    ...features,
                    {
                        key: 'type',
                        label: 'Type',
                        value: upperFirst(this.propertyAppResource.type),
                    },
                    {
                        key: 'yearBuilt',
                        label: 'Year Built',
                        value: this.propertyAppResource.details.yearBuilt,
                    },
                    {
                        key: 'lotSize',
                        label: 'Lot Size',
                        value: lotSizeValue ? niceNumberFormatFilter(lotSizeValue) + ' ' : lotSizeValue,
                        units: lotSizeUnits,
                    },
                    {
                        key: 'price',
                        label: 'Price/sqft',
                        value: (this.propertyAppResource.price && this.propertyAppResource.size)
                            ? '$' + (this.propertyAppResource.price / this.propertyAppResource.size).toFixed(2)
                            : undefined,
                    },
                    {
                        key: 'hoa',
                        label: 'HOA',
                        value: this.propertyAppResource.details.hoa,
                        meta: {
                            rawValue: true,
                        },
                    },
                    {
                        key: 'hoa_includes',
                        label: 'HOA includes',
                        value: this.propertyAppResource.details.associationsFeeIncludes,
                    },
                    {
                        key: 'county',
                        label: 'County',
                        value: upperFirst(this.propertyAppResource.details.county),
                    },
                    {
                        key: 'heating',
                        label: 'Heating',
                        value: upperFirst(this.propertyAppResource.details.heating),
                    },
                    {
                        key: 'cooling',
                        label: 'Cooling',
                        value: upperFirst(this.propertyAppResource.details.ac),
                    },
                ];

                return this.filterFeatures(features);
            },

            secondSection() {
                const rooms = Number(this.propertyAppResource.details.rooms);
                const features = [
                    {
                        key: 'flooring',
                        label: 'Flooring',
                        value: upperFirst(this.propertyAppResource.details.flooring),

                    },
                    {
                        key: 'stories',
                        label: 'Stories',
                        value: upperFirst(this.propertyAppResource.details.storiesLookup),
                    },
                    {
                        key: 'parking',
                        label: 'Parking',
                        value: upperFirst(this.propertyAppResource.details.parking),
                        extraValue: this.propertyAppResource.details.parkingFeatures,
                    },
                    ...((isNaN(rooms) || rooms === 0) ? [] : [{
                        key: 'rooms',
                        label: 'Rooms',
                        value: rooms,
                    }]),
                    {
                        key: 'appliances',
                        label: 'Appliances',
                        value: upperFirst(this.propertyAppResource.details.kitchenAppliances),
                    },
                    {
                        key: 'schools',
                        label: 'Schools',
                        value: upperFirst(this.propertyAppResource.details.schools),
                    },
                    {
                        key: 'openHouses',
                        label: 'Open Houses',
                        value: this.propertyAppResource.details.openHouses,
                    },
                ];

                if (this.propertyAppResource.isSold) {
                    features.push({
                        key: 'airBnb',
                        label: 'AirBnB Est.',
                        value: null,
                    });
                }

                return this.filterFeatures(features);
            },
        },

        methods: {
            isEmpty,

            filterFeatures(features) {
                return features.filter(feature => {
                    const value = feature.value;
                    if (typeof value === 'undefined' || value === null) {
                        return false;
                    }

                    if (value === '') {
                        return false;
                    }

                    if (Array.isArray(value) && !value.length) {
                        return false;
                    }

                    return true;
                });
            },
            /**
             * @param sectionDescriptions {{ :[key, label, value, units] }}
             * @returns {{fields: [], items: []}}
             */
            buildSectionData(sectionDescriptions) {
                let sectionData = {fields: [], items: []};
                let itemsSection = {};

                for (let key in sectionDescriptions) {
                    let sectionDescription = sectionDescriptions[key];

                    let fields = {
                        key: sectionDescription.key,
                        label: sectionDescription.label,
                        tdClass: 'table-data table-data-value',
                    };
                    sectionData.fields.push(fields);

                    let itemIsArray = Array.isArray(sectionDescription.value);
                    const hasValue = sectionDescription.value || sectionDescription.key === 'listed';
                    const hasExtraValue = typeof sectionDescription.extraValue !== 'undefined';

                    let extraValue = hasValue && hasValue ? sectionDescription.extraValue : '';
                    let units = sectionDescription.units ? sectionDescription.units : '';

                    if (!sectionDescription.value && sectionDescription.key !== 'listed') {
                        itemsSection[sectionDescription.key] = '-';
                        continue;
                    }

                    if (get(sectionDescription, 'meta.rawValue') === true) {
                        itemsSection[sectionDescription.key] = sectionDescription.value;
                    } else if (sectionDescription.key === 'openHouses') {
                        let dates = [];
                        for (let value of sectionDescription.value) {
                            dates.push(
                                this.formatTime(value.startTime) + ' - '
                                    + this.formatTime(value.endTime) + ', '
                                    + this.formatDate(value.date)
                            );
                        }
                        itemsSection[sectionDescription.key] = dates;

                    } else {
                        let value = null;
                        if (itemIsArray || (sectionDescription.value && typeof sectionDescription.value === 'object')) {
                            value = this.checkValue(sectionDescription.value).join(', ');
                        } else {
                            //using join will ignore all the null and undefined values
                            value = [
                                sectionDescription.value,
                                extraValue,
                                units,
                            ].join('');
                        }

                        itemsSection[sectionDescription.key] = value;
                    }
                }

                sectionData.items.push(itemsSection);
                return sectionData;
            },


            formatDate(dateString) {
                var date = new Date(dateString),
                    userTimezoneOffset = date.getTimezoneOffset() * 60000;
                return new Date(date.getTime() + userTimezoneOffset).toLocaleDateString(undefined, this.dateOptions);
            },


            formatTime(timeString) {
                let timeSplit = timeString.split(':');
                let hours = parseInt(timeSplit[0]);
                let minutes = timeSplit[1];
                let suffix = hours >= 12 ? 'PM' : 'AM';
                hours = (hours + 11) % 12 + 1;
                return `${hours}:${minutes} ${suffix}`;
            },

            /**
             * @param value
             * @returns {array}
             */
            checkValue(value) {
                if (value && typeof value === 'object') {
                    return Object.values(value);
                }
                return value;
            },
        },
    };
</script>
